/**
 * Shared FeathersJS error handling utilities
 * Used across thunks that need to handle server validation errors
 */

// FeathersJS error response structure
export interface FeathersError {
    name: string;
    message: string;
    code: number;
    className: string;
    errors: Record<string, any>;
}

// DBService response can be either the entity or an error wrapped in {status, data}
export interface DBServiceErrorResponse {
    status: number;
    data: FeathersError;
}

/**
 * Type guard to check if a DB service response is an error
 * @param result - The result from a DB thunk operation
 * @returns True if the result is an error response
 */
export function isDBServiceError(result: any): result is DBServiceErrorResponse {
    return result &&
           typeof result.status === 'number' &&
           result.status >= 400 &&
           result.data &&
           (typeof result.data.code === 'number' ||
            typeof result.data.className === 'string' ||
            result.data.errors !== undefined);
}

/**
 * Extract error message from a DB service error response
 * @param result - The error response
 * @returns The error message string
 */
export function extractDBServiceErrorMessage(result: DBServiceErrorResponse): string {
    return result.data.message || String(result);
}
